module.exports = __webpack_public_path__ + "static/media/logo.f6a4b6fb.png";